/**
 * Okendo review carousel: sync container height to active slide's testimonial card.
 * Uses MutationObserver to detect when .is-active moves and sets container height accordingly.
 */
(function () {
  var CONTAINER_SELECTOR = '.oke-reviewCarousel-slider';
  var ACTIVE_SLIDE_SELECTOR = '.oke-reviewCarousel-reviews-review.is-active.is-current';
  var ACTIVE_SLIDE_FALLBACK = '.oke-reviewCarousel-reviews-review.is-active';
  var CARD_SELECTOR = '.oke-testimonialCard';
  var TRACK_SELECTOR = '.hooper-track';
  var NEXT_BTN_SELECTOR = '.oke-reviewCarousel-next';
  var PREV_BTN_SELECTOR = '.oke-reviewCarousel-prev';
  var OBSERVER_ATTR = 'data-oke-height-observer';

  function syncCarouselHeight(sliderEl) {
    if (!sliderEl) return false;
    var activeSlide = sliderEl.querySelector(ACTIVE_SLIDE_SELECTOR) || sliderEl.querySelector(ACTIVE_SLIDE_FALLBACK);
    if (!activeSlide) return false;
    var card = activeSlide.querySelector(CARD_SELECTOR);
    if (!card) return false;
    var cardHeight = card.offsetHeight || card.getBoundingClientRect().height;
    if (cardHeight > 0) {
      sliderEl.style.height = cardHeight + 'px';
      return true;
    }
    return false;
  }

  function syncAfterLayout(sliderEl, retries) {
    retries = retries || 0;
    var maxRetries = 5;
    function run() {
      if (syncCarouselHeight(sliderEl)) return;
      if (retries < maxRetries) {
        setTimeout(function () { syncAfterLayout(sliderEl, retries + 1); }, 50);
      }
    }
    if (typeof requestAnimationFrame !== 'undefined') {
      requestAnimationFrame(function () {
        requestAnimationFrame(run);
      });
    } else {
      setTimeout(run, 0);
    }
  }

  function scheduleSyncOnSlideChange(sliderEl) {
    syncAfterLayout(sliderEl);
    setTimeout(function () { syncAfterLayout(sliderEl); }, 100);
    setTimeout(function () { syncAfterLayout(sliderEl); }, 250);
    setTimeout(function () { syncAfterLayout(sliderEl); }, 450);
  }

  function scheduleSyncAfterArrowClick(sliderEl) {
    setTimeout(function () { syncAfterLayout(sliderEl); }, 50);
    setTimeout(function () { syncAfterLayout(sliderEl); }, 150);
    setTimeout(function () { syncAfterLayout(sliderEl); }, 300);
    setTimeout(function () { syncAfterLayout(sliderEl); }, 500);
  }

  function attachToSlider(sliderEl) {
    if (sliderEl.getAttribute(OBSERVER_ATTR) === '1') return;
    sliderEl.setAttribute(OBSERVER_ATTR, '1');

    syncAfterLayout(sliderEl);

    var track = sliderEl.querySelector(TRACK_SELECTOR);
    if (track) {
      var observer = new MutationObserver(function () {
        scheduleSyncOnSlideChange(sliderEl);
      });
      observer.observe(track, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true
      });
    }

    var nextBtn = sliderEl.querySelector(NEXT_BTN_SELECTOR);
    var prevBtn = sliderEl.querySelector(PREV_BTN_SELECTOR);
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scheduleSyncAfterArrowClick(sliderEl);
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scheduleSyncAfterArrowClick(sliderEl);
      });
    }
  }

  function findAndAttach() {
    var sliders = document.querySelectorAll(CONTAINER_SELECTOR);
    for (var i = 0; i < sliders.length; i++) {
      attachToSlider(sliders[i]);
    }
  }

  function getSliderFromClickTarget(target) {
    var el = target;
    while (el && el !== document.body) {
      if (el.classList && (el.classList.contains('oke-reviewCarousel-next') || el.classList.contains('oke-reviewCarousel-prev'))) {
        var slider = el.parentElement;
        while (slider && slider !== document.body) {
          if (slider.classList && slider.classList.contains('oke-reviewCarousel-slider')) return slider;
          slider = slider.parentElement;
        }
        return null;
      }
      el = el.parentElement;
    }
    return null;
  }

  function init() {
    findAndAttach();
    var watch = new MutationObserver(function () {
      findAndAttach();
    });
    watch.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('click', function (e) {
      var slider = getSliderFromClickTarget(e.target);
      if (slider) scheduleSyncAfterArrowClick(slider);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
